/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  color: #36ded6;

  h1 {
    margin-bottom: 50px;
  }

  div {
    width: 600px;
    max-width: 600px;
    margin: 0px auto;
    font-size: 18px;
    margin-bottom: 10px;
    text-align: justify;
  }
`;
